export function useClassModuleRegistry(modules = []) {
    return new Map(modules.map((module) => [module.model.name, module]));
}
